module.exports = __webpack_public_path__ + "static/img/vpc.c46e267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sdwan/vpc.png
// module id = rXe6
// module chunks = 0